import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BrandingService } from '@feature/branding';
import { EnvironmentService } from '@util/environment';
import { CookiesService } from '../../cookies.service';

@Component({
  selector: 'feature-cookies-overlay',
  templateUrl: './cookies-overlay.component.html',
  styleUrls: ['./cookies-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CookiesOverlayComponent {
  private readonly cookiesService: CookiesService = inject(CookiesService);
  private readonly env: EnvironmentService = inject(EnvironmentService);
  private readonly brandingService: BrandingService = inject(BrandingService);

  readonly showOverlay$ = this.cookiesService.showOverlay$;

  close(): void {
    this.cookiesService.closeOverlay();
  }

  manageCookies(): void {
    this.cookiesService.openManageCookiesDialog();
  }

  openTermsAndConditions(): void {
    window.open(this.brandingService.branding().termsAndConditionsURL);
  }

  openPrivacyStatement(): void {
    window.open(this.brandingService.branding().privacyStatementURL);
  }
}
